








import Vue from 'vue';
import Component from 'vue-class-component';
import { Global } from '@/store';

@Component({})
class About extends Vue {
    version_num = 'v-2.67.1.8';
    @Global.Mutation('setPageTitle') setPageTitle;

    mounted() {
        this.setPageTitle('About');
    }
}

export default About;
